import { render, staticRenderFns } from "./Adaptive.vue?vue&type=template&id=49fd64ed&scoped=true"
import script from "./Adaptive.vue?vue&type=script&lang=js"
export * from "./Adaptive.vue?vue&type=script&lang=js"
import style0 from "./Adaptive.vue?vue&type=style&index=0&id=49fd64ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd64ed",
  null
  
)

export default component.exports